// Settings → Integrations — every external connection in one place, one
// sub-tab per service. Gmail is per-user (all roles); the API-key services
// (Follow Up Boss, BombBomb) stay Admin-only, matching their old top-level
// tabs. Old deep links (?tab=gmailConnection|followUpBoss|bombBomb) land here
// via the LEGACY_SETTINGS_TAB_MAP in main-settings.jsx.
import { useEffect, useState } from "react";
import { useStateValue } from "../../context/StateProvider";
import GmailConnectionCard from "./gmail-connection-card";
import FollowUpBossTab from "./follow-up-boss-tab";
import BombBombTab from "./bombbomb-tab";

const SUB_TABS = [
  { id: "gmail", label: "Gmail", roles: ["Admin", "Supervisor", "Employee"] },
  { id: "followUpBoss", label: "Follow Up Boss", roles: ["Admin"] },
  { id: "bombBomb", label: "BombBomb", roles: ["Admin"] },
];

function IntegrationsTab({ initialSub = "gmail" }) {
  const [{ user }] = useStateValue();
  const visible = SUB_TABS.filter((t) => t.roles.includes(user?.role));
  const [sub, setSub] = useState(initialSub);

  // Deep links can change the requested sub-tab after mount (e.g. the contacts
  // page's "connect Gmail" link while Settings is already open).
  useEffect(() => {
    setSub(initialSub);
  }, [initialSub]);

  const active = visible.find((t) => t.id === sub) ? sub : visible[0]?.id;

  return (
    <div>
      <div className="flex flex-row gap-1 border-b border-black/10 mb-4">
        {visible.map((t) => (
          <button
            key={t.id}
            type="button"
            onClick={() => setSub(t.id)}
            className={`text-sm font-medium px-4 py-2 rounded-t-md transition-colors border-b-2 -mb-[1px] ${
              active === t.id
                ? "border-indigo-500 text-indigo-700 bg-indigo-50"
                : "border-transparent text-slate-600 hover:text-slate-900 hover:bg-slate-100"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {active === "followUpBoss" ? (
        <FollowUpBossTab />
      ) : active === "bombBomb" ? (
        <BombBombTab />
      ) : (
        <GmailConnectionCard />
      )}
    </div>
  );
}

export default IntegrationsTab;
